import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import emailPage from "./slices/emailPage";
import onboarding from "./slices/onBoardingSlice";
import supplier from "./slices/supplier";

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const supplierPersistConfig = {
  key: "supplier",
  storage,
  keyPrefix: "redux-",
  whitelist: ["supplier"],
};

const pagePersistConfig = {
  key: "page",
  storage,
  keyPrefix: "redux-",
  whitelist: ["page"],
};

const onboardingPersistConfig = {
  key: "onboarding",
  storage,
  keyPrefix: "redux-",
  whitelist: ["onboarding"],
};

const rootReducer = combineReducers({
  page: persistReducer(pagePersistConfig, emailPage),
  supplier: persistReducer(supplierPersistConfig, supplier),
  onboarding: persistReducer(onboardingPersistConfig, onboarding),
});

export { rootPersistConfig, rootReducer };
